import React, { FC, useEffect, useState } from 'react'
import { AnnouncementBanner } from './subcomponents'

//* utils
import { ComponentAnnouncement } from '../../../models/components/announcement'
import { returnSelectedLocaleData } from '../../../utils/functions.utils'
import announcementStaticQuery from './announcementStaticQuery'

type Props = {
  announcementData: ComponentAnnouncement | null
  locale: string
  page?: string
}

const Announcement: FC<Props> = ({ announcementData, locale, page }) => {
  const [announcement, setAnnouncement] = useState<ComponentAnnouncement | null>(null)
  const query = announcementStaticQuery?.allContentfulComponentAnnouncement() || null
  const dynamicData = announcementData || query || {}

  const renderAppropriateBanner = () => {
    const edges =
      'allContentfulComponentAnnouncement' in dynamicData
        ? dynamicData?.allContentfulComponentAnnouncement?.edges
        : [dynamicData]

    if (Array.isArray(edges) && locale) {
      const announcementToRender = returnSelectedLocaleData(edges, locale)

      //* If the unpublish date is in the past it shouldn't be shown
      const unpublishedData = new Date(announcementToRender.unpublishDate) > new Date()
      //* If the publish date is later than today it shouldn't be shown
      const publishedDate = new Date() < new Date(announcementToRender.publishDate)
      const dontShowBanner = unpublishedData || publishedDate

      if (announcementToRender.length && !dontShowBanner) {
        if (typeof window !== `undefined`) {
          setAnnouncement(announcementToRender[0].node)
        } else {
          return announcementToRender[0].node
        }
      }
    }
  }

  useEffect(() => {
    renderAppropriateBanner()
  }, [page])

  const dynamicAnnouncement = () => {
    const announcementData = typeof window == `undefined` ? renderAppropriateBanner() : announcement

    if (announcementData?.useCase === page) {
      const iconSrc = announcementData?.icon?.image?.file?.url || ''
      const iconAlt = announcementData?.icon?.altText || ''
      const text = announcementData?.text || ''

      return <AnnouncementBanner iconSrc={iconSrc} iconAlt={iconAlt} text={text} />
    } else {
      return null
    }
  }

  return announcement ? dynamicAnnouncement() : null
}

export default Announcement
